import { User, UserStrings } from "~/types/entities";

type TFAQ = {
  [key in User]: {
    question: string;
    answer: string;
  }[];
};

type TFAQSection = TFAQ & {
  title: string;
};

interface IAnswerScheme {
  "@type": string;
  text: string;
}

interface IQuestionScheme {
  "@type": string;
  name: string;
  acceptedAnswer: IAnswerScheme;
}

interface IFAQScheme {
  "@context": string;
  "@type": string;
  mainEntity: IQuestionScheme[];
}

const getFAQScheme = (value: UserStrings) => {
  const { tm, rt } = useI18n();
  const faqSection: TFAQSection = tm("faq_section");

  const FAQScheme: IFAQScheme = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: [],
  };

  let faqSectionKey: UserStrings | "title";
  let mainEntity: IQuestionScheme[] = [];

  for (faqSectionKey in faqSection) {
    if (faqSectionKey === "title") {
      continue;
    }

    mainEntity = faqSection[value].map((item) => ({
      "@type": "Question",
      name: rt(item.question),
      acceptedAnswer: {
        "@type": "Answer",
        text: rt(item.answer),
      },
    }));

    break;
  }

  FAQScheme.mainEntity = mainEntity;

  return FAQScheme;
};

export default getFAQScheme;
